/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/react-in-jsx-scope */
import React, { useState, useEffect } from 'react';
import { ReactComponent as RightArrowIcon } from 'Assets/salesgear/svg/down-arrow.svg';
import sequenceStoreData from 'Stores/sequenceData';
import { observer } from 'mobx-react';

const Folders = observer(props => {
  const { setSequenceLoading } = props;
  const [folderData, setFolderData] = useState('');
  const [loading, setLoading] = useState(true);

  const removeSelectedClass = () => {
    const target = document.getElementsByClassName('folder');
    if (target && target.length) {
      const array = Array.from(target);
      array.forEach((ele, index) => {
        if (ele) ele.classList.remove('selected');
      });
    }
  };

  const getFolderResponse = (e, folderId) => {
    if (e) {
      const dataValue = e.getAttribute('data-name');
      setSequenceLoading(true);
      if (dataValue)
        switch (dataValue) {
          case 'My Sequences':
            sequenceStoreData.getAllSequenceData();
            break;
          case 'Shared Sequences':
            sequenceStoreData.getSharedSequence();
            break;
          default:
            sequenceStoreData.getFolderResponseById(folderId);
        }
    }
  };

  const folderClickAction = (e, folderId) => {
    if (e) {
      const { currentTarget } = e;
      removeSelectedClass();
      currentTarget.classList.add('selected');
      getFolderResponse(currentTarget, folderId);
    }
  };

  useEffect(() => {
    if (sequenceStoreData.allFolderResponse) {
      setFolderData(sequenceStoreData.allFolderResponse);
      setLoading(false);
    }
  }, [sequenceStoreData.allFolderResponse]);

  return !loading ? (
    <div className="folderCont">
      <div className="folderListCont">
        <MySequenceFolder cbk={folderClickAction} />
        <SharedSequneceFolder cbk={folderClickAction} />
        <div className="dynamicFoldersWrapper" style={{ width: '100%' }}>
          <DynamicFolder folderData={folderData} cbk={folderClickAction} />
        </div>
      </div>
    </div>
  ) : (
    <div className="folderLoadingWrapper">
      <FolderLoader loadingNumber={10} />
    </div>
  );
});

const FolderLoader = props => {
  const noOfLoader = props.loadingNumber ? props.loadingNumber : 1;
  return Array.from({ length: noOfLoader }, (value, index) => (
    <div className="newFolderLoader" key={`folderLoader${index}`}>
      <span className="folderIcon linear-background" />
      <div className="folderName linear-background" />
      <div className="arrowIcon linear-background" />
    </div>
  ));
};

const MySequenceFolder = props => {
  const { cbk } = props;
  return (
    <div
      className="folder selected"
      data-name="My Sequences"
      onClick={e => cbk(e)}
    >
      <span className="folderIcon" />
      <span className="folderName name">My Sequences</span>
      <span className="rightArrow">
        <RightArrowIcon />
      </span>
    </div>
  );
};

const SharedSequneceFolder = props => {
  const { cbk } = props;
  return (
    <div
      className="folder"
      data-id="shared"
      data-name="Shared Sequences"
      onClick={e => cbk(e)}
    >
      <span className="sharedSeqFolder" />
      <span className="folderName name ">Shared Sequences</span>
      <span className="rightArrow">
        <RightArrowIcon />
      </span>
    </div>
  );
};

const DynamicFolder = props => {
  const { cbk, folderData } = props;

  return (
    folderData &&
    folderData.length > 0 &&
    folderData.map((folderVal, index) => {
      const { folderName, id } = folderVal;
      return (
        <div
          className="folder"
          key={index}
          data-name={folderName}
          data-id={id}
          onClick={e => cbk(e, id)}
        >
          <span className="folderIcon" />
          <span className="folderName name">{folderName}</span>
          <span className="rightArrow">
            <RightArrowIcon />
          </span>
        </div>
      );
    })
  );
};

export default Folders;
export { Folders };
